import React, { useEffect, useState } from 'react'
import List from '@material-ui/core/List'
import { useRest } from '../../contexts/rest/use'
import { useConfig } from '../../contexts/config/use'
import { QueueListItem } from './queue_listitem'
import { RedirectButton } from './redirectbutton'
import { Header } from '../header'
import { Footer } from '../footer'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useTranslation } from '../../contexts/i18n/use'
import CircularProgress from '@material-ui/core/CircularProgress'
import { QueueEmptyListItem } from './queue_emptylistitem'
import { useHistory } from "react-router-dom"
import { isFalsyOrEmpty } from '../helpers/object'
import { TicketFailureModal } from './ticketfailuremodal'
import { Queuedata } from '../../services/dto/queuedata.dto'

export const QueueDisplay = () => {
  const { state: { selectedoffice, queues, wasticketfailure }, actions: { handleTakeTicket, qrToQueueSelection } } = useRest();
  const { state: { config }, actions: {GetOfficeIDFromUrlID, CheckIfHasForm, LoadAll }} = useConfig();
  const [disablebuttons, setDisableButtons] = useState(false);
  const [officeid, setOfficeID] = useState();
  const [failure, setFailure] = useState(null);
  const [hasloaded, setHasLoaded] = useState(false);
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (config)
    {
      sessionStorage.removeItem("formdata");

      var oldbaseurl = localStorage.getItem("baseurl");
      if (window.location.pathname !== oldbaseurl)
      {
        setHasLoaded(false);
        localStorage.removeItem("ticket");
        localStorage.removeItem("tickettext");
        localStorage.removeItem("selectedoffice");
        localStorage.removeItem("selectedqueuename");
        sessionStorage.removeItem("resources");
        sessionStorage.removeItem("queuename");
        sessionStorage.removeItem("formdata");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("tokenconfig");
        localStorage.setItem("baseurl", window.location.pathname);
        LoadAll();
        window.location.reload();
        return;
      }

      const savedticket = JSON.parse(localStorage.getItem("ticket"));
      if (!isFalsyOrEmpty(savedticket) && !savedticket.cancelled)
        history.push("ticket");
      else
      {
        let urlid = GetOfficeIDFromHash();
        if(urlid)
        {
          var result = GetOfficeIDFromUrlID(urlid);
          if (!result)
            history.push("404")
          else
            setOfficeID(result);
        }
      }
      setHasLoaded(true);
    }
  },[config])

  useEffect(() => {
    if (officeid)
    {
      var hash = window.location.hash.split("?")
      window.history.replaceState({}, '', window.location.origin + window.location.pathname + hash[0])
      qrToQueueSelection(officeid);
    }
  }, [officeid])

  useEffect(() => {
    if (wasticketfailure)
      setFailure(true);
    else 
      setFailure(null);
  },[wasticketfailure])

  const GetOfficeIDFromHash = () => {
    if ( window.location.hash && Object.keys(window.location.hash).length > 0)
    {
      var hashpath = window.location.hash.substr(1);
      var queryparams = hashpath.split('?');
      if (queryparams && queryparams.length > 1)
      {
        var result = queryparams[1].split('=');
        if (result[0] === "officeID")
          return result[1];
        else
          return null;
      }
    }
  }

  const handleDisable = value => {
    setDisableButtons(value);
  }

  if ((disablebuttons && !wasticketfailure) || !hasloaded)
  {
    return (
      <div className={classes.spinnerwrapper}>
        <CircularProgress className={[classes.spinner, "Spinner"].join(' ')} />
      </div>
    )
  }
  else
  {
    return (
      <div className={classes.container}>
        <Header />
        <div className={classes.outerbox}>
          <div className={classes.innerbox}>
            {
              !isFalsyOrEmpty(config) 
              ? 
              <List className={classes.list}>
                { (!isFalsyOrEmpty(queues) && queues.length > 0) 
                    ? queues.map((x,i) => { return <QueueListItem key={"QLItem_" + i} 
                                                                        queuedata={x}
                                                                        officeID={selectedoffice} 
                                                                        bookTicket={handleTakeTicket}
                                                                        disabled={disablebuttons}
                                                                        hasform={CheckIfHasForm(selectedoffice, new Queuedata(x.queueID, "", ""))}
                                                                        disablecallback={handleDisable}
                                                                        /> }) 
                    : <QueueEmptyListItem/>
                }
              </List>
              : <CircularProgress className={[classes.spinner, "Spinner"].join(' ')} id="queue-spinner"/>
            }
            { failure ? <TicketFailureModal disablecallback={handleDisable}/> : <></>}
            <div className={classes.buttonwrapper}>
              { (config && config.shouldHaveRedirectButton) ? <RedirectButton url={config.redirectionLink} text={t('queuepage.redirectbuttontext')} /> : <span/> }
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )
  }
}

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: '1 0 auto',
  },
  outerbox: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
    overflow: 'auto'
  },
  innerbox: {
    display: 'flex', 
    flexDirection: 'column', 
    flex: '1 0 auto', 
    height: '100%'
  },
  buttonwrapper: {
    marginTop: 'auto',
    marginBottom: '1rem',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 0.5rem'
  },
  spinner: theme => ({
    color: theme.palette.primary.main,
    height: '80%',
    width: '80%'
  }),
  spinnerwrapper: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
})
